// TODO: mover componente a ats-app: Configuracion de etapa
import { Button, Checkbox, Divider, Form, Input, InputNumber, Select, Switch, Tooltip } from "antd";
import React, { useState } from "react";
import UserInforContent from "@frontend/components/shared/user-info-content/UserInfoContent";
import LabelTooltip from "@frontend/components/shared/label-tooltip/LabelTooltip";
import AdvancementRequirements from '../../organism/AdvancementRequirements'
import Text from "antd/lib/typography/Text";
import Title from "antd/lib/typography/Title";
const FormEditStep = ({
  handleSubmitEdit,
  initValues = {},
  handleInfiniteScroll,
  handleSelect,
  loading,
  onSearch,
  userList,
  handleDeselect,
  disableSubmit,
  emailTemplates=[],
  templates = [],
  form,
}) => {
  const { getFieldDecorator } = form;
  const {
    name = "",
    user_columns = [],
    report_templates = null,
    move_templates = null,
    disqualify_templates = null,
    external_users = "",
    userColumnsActive,
    authorActive,
    responsibleActive,
    managersActive,
    slaSetting = null,
    enable_limit_applicants
  } = initValues;

  const [userColsChecked, setUserCols] = useState(userColumnsActive);
  const [checked, setChecked] = useState(slaSetting?.active)
  const onClickUserColCheck = (element) => {
    setUserCols(element.target.checked);
  };

  return (
    <Form
      layout="vertical"
      onSubmit={(e) => handleSubmitEdit(e, form)}
      labelCol={{ span: 4 }}
    >
      <Form.Item
        name="name"
      >
        {getFieldDecorator("name", { initialValue: name, rules: [{ required: true, message: "Debes ingresar un nombre" }] })(<Input />)}
      </Form.Item>
      <Form.Item name="user_columns">
        <LabelTooltip
          tooltip="Estos usuarios podrán gestionar solo las etapas en las
          que han sido asigandos como encargados"
          label="Seleccionar encargados"
        />
        <div style={{ marginBottom: "10px" }}>
          {getFieldDecorator("user_columns_active", {
            initialValue: userColumnsActive,
            valuePropName: "checked",
          })(
            <Checkbox onClick={onClickUserColCheck}>
              Usuarios específicos
            </Checkbox>
          )}
          {getFieldDecorator("author_active", {
            initialValue: authorActive,
            valuePropName: "checked",
          })(<Checkbox>Creador</Checkbox>)}
          {getFieldDecorator("responsible_active", {
            initialValue: responsibleActive,
            valuePropName: "checked",
          })(<Checkbox>Responsable</Checkbox>)}
          {getFieldDecorator("managers_active", {
            initialValue: managersActive,
            valuePropName: "checked",
          })(<Checkbox>Manager</Checkbox>)}
        </div>

        {userColsChecked && (
          <>
            <label className="ant-form-item-label">
              Selecciona usuarios específicos
            </label>
            {getFieldDecorator("user_columns", { initialValue: user_columns })(
              <Select
                style={{ width: "100%" }}
                optionFilterProp="label"
                loading={loading}
                onSelect={handleSelect}
                onPopupScroll={handleInfiniteScroll}
                onSearch={onSearch}
                mode="multiple"
                onDeselect={handleDeselect}
                optionLabelProp="label"
              >
                {userList.data.map((item) => (
                  <Select.Option
                    key={item.id}
                    value={item.id}
                    label={`${item.full_name} - ${item.email}` || ""}
                  >
                    <UserInforContent user={item} />
                  </Select.Option>
                ))}
              </Select>
            )}
          </>
        )}
      </Form.Item>
      <Form.Item
        name="external_users"
        rules={[
          { required: true, message: "Por favor ingrese al menos un correo" },
        ]}
      >
        <LabelTooltip
          tooltip="Estos usuarios recibirán via email las plantillas asignadas
          a la etapa sin acceder al proceso, debe colocar los emails separados por punto y coma ';'"
          label="Usuarios externos"
        />
        {getFieldDecorator("external_users", { initialValue: external_users })(
          <Input />
        )}
      </Form.Item>
      <Form.Item name="report_templates">
        <LabelTooltip
          tooltip="Esta plantilla sera enviada via email a los usuarios externos"
          label="Seleccionar plantilla"
        />
        {getFieldDecorator("report_templates", {
          initialValue: report_templates,
        })(
          <Select
            showSearch
            filterOption={(input, option) =>
              (option?.props.label || '')
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            style={{ width: "100%" }}
            optionFilterProp="label"
            optionLabelProp="label"
          >
            {templates
              .filter((item) => item.active)
              .map((item) => (
                <Select.Option key={item.id} value={item.id} label={item.title}>
                  {item.title}
                </Select.Option>
              ))}
          </Select>
        )}
      </Form.Item>
      <Title className="modal_titles">
        Correos
      </Title>
      
      <Form.Item name="move_templates">
        <LabelTooltip
          tooltip="Se generará una notificación por correo automática, cuando los candidatos sean movidos hacia esta etapa"
          label="Mover candidatos"
        />
        {getFieldDecorator("move_templates", {
          initialValue: move_templates,
        })(
          <Select
            showSearch
            filterOption={(input, option) =>
              (option?.props.label || '')
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            style={{ width: "100%" }}
            optionFilterProp="label"
            optionLabelProp="label"
          >
            {emailTemplates
              .filter((item) => item.active)
              .map((item) => (
                <Select.Option key={item.id} value={item.id} label={item.title}>
                  {item.title}
                </Select.Option>
              ))}
          </Select>
        )}
      </Form.Item>

      <Form.Item name="disqualify_templates">
        <LabelTooltip
          tooltip="Selecciona la plantilla que se utilizará para descalificar candidatos en esta etapa"
          label="Descalificar candidatos"
        />
        {getFieldDecorator("disqualify_templates", {
          initialValue: disqualify_templates,
        })(
          <Select
            showSearch
            filterOption={(input, option) =>
              (option?.props.label || '')
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            style={{ width: "100%" }}
            optionFilterProp="label"
            optionLabelProp="label"
          >
            {emailTemplates
              .filter((item) => item.active)
              .map((item) => (
                <Select.Option key={item.id} value={item.id} label={item.title}>
                  {item.title}
                </Select.Option>
              ))}
          </Select>
        )}
      </Form.Item>

      <AdvancementRequirements form={form} initialValues={initValues}/>
      <Title className="modal_titles">
        Activar tiempo máximo de etapa
      </Title>
      <div className="sla-container">
        <Text style={{width: "80%"}}>
          Al activar esta configuración podrás establecer el tiempo máximo que este candidato puede estar dentro de la etapa sin ser movido.
        </Text>
        <Switch checked={checked} onChange={(check)=> setChecked(check)} checkedChildren="Si" unCheckedChildren="No" />
      </div>
      {checked &&
        <Form.Item style={{marginTop: 20}} name="sla_count">
          <LabelTooltip
            tooltip="Días hábiles máximos en los que se empezarán a mandar correos en caso de ser superado."
            label="Días hábiles"
          />
          {getFieldDecorator("sla_count", {
            initialValue: slaSetting?.max_days,
          })(
            <InputNumber style={{width: "100%"}} min={1}/>
          )}
        </Form.Item>
      }

      <Title className="modal_titles">Alta de candidatos</Title>
      <div className="sla-container">
        <Text style={{ width: "80%" }}>
          Si seleccionas esta opción, el acceso para iniciar altas a candidatos estará limitado únicamente a las etapas que hayas marcado.
        </Text>
        <Form.Item style={{ marginTop: 20 }}>
          {getFieldDecorator("enable_limit_applicants", {
            initialValue: enable_limit_applicants,
            valuePropName: "checked",
          })(
            <Switch
              checkedChildren="Si"
              unCheckedChildren="No"
            />
          )}
        </Form.Item>
      </div>

      <Divider/>
      <Form.Item>
        <Button type="primary"  htmlType="submit" disabled={disableSubmit} style={{ float: "right" }}>
          Guardar
        </Button>
      </Form.Item>
    </Form>
  );
};

const FormEditStepForm = Form.create({ name: "control-hooks" })(FormEditStep);

export default FormEditStepForm;
